import { AssetRef } from '../../../types';

export function parseAssetRefs(assetRefs?: string | null): AssetRef[] {
  if (!assetRefs) return [];
  try {
    const parsed = JSON.parse(assetRefs);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
